import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';

class AboutUs extends Component {
  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Hidream讯梦国际公司简介，发展历程，企业资质/易赛诺公司简介，发展历程，企业资质"
          />
          <meta
            name="description"
            content="Hidream讯梦国际团队深耕海外营销10余年，自2006年成立起，始终专注于出海领域，获得海外主流平台顶级代理商资质。"
          />
        </Head>

        <div id="aboutUs" className="aboutUs">
          <div className="introduction bb">
            <div className="left">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidreamzhutituan"></use>
                  </svg>
                  <span>Hidream简介</span>
                </h3>
                <p>Introduction to hidream</p>
              </div>
              <div className="content">
                <p>
                  Hidream—易赛诺（杭州）科技有限公司—专注中国品牌海外推广的跨境出海服务商。
                  <br />
                  自成立以来，先后成为Google、Facebook、Bing、Instagram、YouTube、TikTok、Twitter、Yandex、Linkedln等主流海外平台顶级代理商，专注中国品牌海外推广，为中国出海企业提供免费开户、广告投放、品牌孵化等服务。
                  <br />
                  目前成功孵化百万级DTC品牌30余个，涉及假发、家纺、服装、眼镜、家具等行业。已服务超5000余家中国品牌企业出海推广，为1000多家外贸企业培训输送2000余跨境电商人才，培训覆盖人数近15000人次。
                </p>
              </div>
            </div>

            <div className="right">
              <Image
                src={require('../public/images/电脑.png').default}
                alt="电脑"
              />
            </div>
          </div>

          <div className="developmentPath">
            <div className="bb">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidreamzhutituan"></use>
                  </svg>
                  <span>发展历程</span>
                </h3>
                <p>Development path</p>
              </div>

              <div className="inner-content">
                <Image
                  className="content"
                  src={require('../public/images/发展历程.png').default}
                  alt="发展历程"
                />
              </div>
            </div>
          </div>

          <div className="qualification bb">
            <div className="section_header_2">
              <h3>
                <svg className="icon" aria-hidden="true">
                  <use xlinkHref="#icon-hidreamzhutituan"></use>
                </svg>
                <span>企业资质</span>
              </h3>
              <p>Qualification</p>
            </div>

            <div className="inner-content">
              <div className="content-wrapper">
                <div className="Google content-block">
                  <Image
                    className="image"
                    src={require('../public/images/Google.jpg').default}
                    alt="Google"
                    layout="responsive"
                  />
                  <div className="bottom">
                    <div className="title">Google核心合作伙伴</div>
                    <div className="content">
                      <p>2006年：获得Google核心合作伙伴资质</p>
                      <p>2012年：所服务企业入选Google中国 “十大经典案例”</p>
                      <p>2017年：实现独立站销售额从0-双百万美金</p>
                      <p>
                        目前可服务的社媒、搜索引擎渠道及代理资质
                        <br />
                        <span>TikTok、Twitter、LinkedIn二代</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="Facebook content-block">
                  <Image
                    className="image"
                    src={require('../public/images/Facebook.jpg').default}
                    alt="Facebook"
                    layout="responsive"
                  />
                  <div className="bottom">
                    <div className="title">Facebook官方认可代理商</div>
                    <div className="content">
                      <p>
                        2018年成为Facebook官方认可的代理商，专注于中国品牌海外推广，为国内企业提供海外网络推广、广告营销课程及独立站建设的一站式海外推广解决方案。
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="content-bottom">
                <Image
                  src={require('../public/images/代理logo.png').default}
                  alt="代理logo"
                />

                <p>等主流海外平台顶级代理商</p>
              </div>
            </div>
          </div>

          <div className="contactus">
            <div className="bb">
              <div className="section_header_2">
                <h3>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidreamzhutituan"></use>
                  </svg>
                  <span>联系我们</span>
                </h3>
                <p>Contact Us</p>
              </div>

              <div className="contactus_content inner-content">
                <div className="map">
                  <Image
                    src={require('../public/images/map_pc.jpg').default}
                    alt="map"
                  />
                </div>

                <div className="joinus">
                  <div className="hover">
                    <div className="hover-content show">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamjiaru"></use>
                      </svg>
                      <span>加入我们</span>
                    </div>
                    <div className="hover-content hidden">
                      E-mail：zhouyujie@Hidream.net
                    </div>
                  </div>

                  <div className="hover">
                    <div className="hover-content show">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamshichang"></use>
                      </svg>
                      <span>市场合作</span>
                    </div>
                    <div className="hover-content hidden">
                      E-mail：wangrui@Hidream.net
                    </div>
                  </div>

                  <div className="hover">
                    <div className="hover-content show">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamshangwu2"></use>
                      </svg>
                      <span>商务合作</span>
                    </div>
                    <div className="hover-content hidden">
                      E-mail：yeguanghui@Hidream.net
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutUs;
